import { render, staticRenderFns } from "./DisputeAttachment.vue?vue&type=template&id=456089c4&scoped=true"
import script from "./DisputeAttachment.vue?vue&type=script&lang=js"
export * from "./DisputeAttachment.vue?vue&type=script&lang=js"
import style0 from "./DisputeAttachment.vue?vue&type=style&index=0&id=456089c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456089c4",
  null
  
)

export default component.exports